export default __webpack_public_path__ + "static/media/binance.c632d4f2.svg";